<template>
  <div class="p-2 pt-7 container-fluid">
    <div class="row form-row">
      <div class="col-sm-12">
        <div class="card">
          <div class="card-header p-2">
          </div>
          <div class="p-2 card-body">
            <!--Mensaje inicial-->
            <div v-if="!successMessageSent"
              class="row form-row list-group-item border-0 d-flex p-3 mb-2 w-100 d-flex justify-content-center">
              <h6 class="mb-3 text-lg text-center">
                <i class="fas fa-exclamation-circle fa-3x" style="color: #63e6be"></i>
              </h6>
              <p class="text-lg text-center">
                Hemos enviado un código de verificación a su
                {{
                  contactMethod === "phone"
                    ? "número de teléfono"
                    : "número de teléfono"
                }}:
              </p>
              <h6 class="mb-3 text-md text-center">
                <i class="fas fa-phone me-2"></i>
                {{ phone }}
              </h6>
            </div>

            <!--Codigo de verificacion-->
            <div v-if="!successMessageSent"
              class="row form-row list-group-item border-0 d-flex p-3 py-4 mb-4 bg-gray-100 border-radius-lg w-100 d-flex justify-content-center">
              <p class="text-md">Ingresa el código para continuar:</p>

              <div class="col-lg-4 col-md-6 col-12 mt-4">
                <div class="row form-row gx-2 gx-sm-3">
                  <div class="col-2">
                    <input type="tel" class="form-control text-center text-lg form-control-lg px-0" maxlength="1"
                      autocomplete="off" @input="moveToNext($event, 1)" @keydown.backspace="moveToPrevious($event, 1)"
                      v-model="code[0]" />
                  </div>
                  <div class="col-2">
                    <input type="tel" class="form-control text-center text-lg form-control-lg px-0" maxlength="1"
                      autocomplete="off" @input="moveToNext($event, 2)" @keydown.backspace="moveToPrevious($event, 2)"
                      v-model="code[1]" />
                  </div>
                  <div class="col-2">
                    <input type="tel" class="form-control text-center text-lg form-control-lg px-0" maxlength="1"
                      autocomplete="off" @input="moveToNext($event, 3)" @keydown.backspace="moveToPrevious($event, 3)"
                      v-model="code[2]" />
                  </div>
                  <div class="col-2">
                    <input type="tel" class="form-control text-center text-lg form-control-lg px-0" maxlength="1"
                      autocomplete="off" @input="moveToNext($event, 4)" @keydown.backspace="moveToPrevious($event, 4)"
                      v-model="code[3]" />
                  </div>
                  <div class="col-2">
                    <input type="tel" class="form-control text-center text-lg form-control-lg px-0" maxlength="1"
                      autocomplete="off" @input="moveToNext($event, 5)" @keydown.backspace="moveToPrevious($event, 5)"
                      v-model="code[4]" />
                  </div>
                  <div class="col-2">
                    <input type="tel" class="form-control text-center text-lg form-control-lg px-0" maxlength="1"
                      autocomplete="off" @keydown.backspace="moveToPrevious($event, 6)" v-model="code[5]" />
                  </div>
                </div>

                <div class="text-center">
                  <router-link :to="{ name: 'Verificacion Elector' }">
                    <argon-button class="mt-0 mb-3 mt-4 btn-lg py-4 text-lg text-white" color="success" full-width
                      :disabled="isButtonDisabled || loading" @click="sendCodeSuccess">
                      <i v-if="!loading" class="fas fa-check pe-2"></i>
                      <i v-if="loading" class="fas fa-spinner fa-spin me-2"></i>

                      <span v-if="loading">Verificando...</span>
                      <span v-else>Verificar Código</span>
                    </argon-button>
                  </router-link>

                  <span class="text-md text-muted">
                    ¿No ha recibido un código?
                    <span v-if="resendingCode" class="btn btn-link text-dark p-0 mb-1">
                      Enviando código<i class="fas fa-spinner fa-spin ms-2"></i>
                    </span>
                    <button v-else @click="resendCode" class="btn btn-link text-dark p-0 mb-1">
                      Reenviar código
                    </button>
                  </span>
                </div>
              </div>
            </div>

            <!--Confirmacion-->
            <div v-if="successMessageSent && !errorOccurred"
              class="row form-row list-group-item border-0 d-flex p-3 mb-2 w-100 d-flex justify-content-center">
              <h6 class="mb-3 text-lg text-center">
                <i class="fas fa-check-circle fa-5x" style="color: #63e6be"></i>
              </h6>
              <p class="text-lg text-center">
                ¡Su voto ha sido enviado exitosamente!
              </p>
              <p class="text-md text-center">¡Gracias por su tiempo!</p>
              <div v-if="usuarioRol === 'usuario'" class="text-center mt-4">
                <argon-button class="btn-lg py-4 text-lg text-white" color="cyan" @click="goToInicio">
                  <i class="fas fa-home me-2"></i> Volver al inicio
                </argon-button>
              </div>
              <div v-else class="text-center mt-4">               
                <i class="fas fa-spinner fa-spin me-2"></i> Volviendo al formulario de elector...                
              </div>
            </div>

            <!--Mensaje de error-->
            <div v-if="errorOccurred"
              class="row form-row list-group-item border-0 d-flex p-3 mb-2 w-100 d-flex justify-content-center"
              style="background-color: #f8d7da; border-color: #f5c6cb;">
              <h6 class="mb-3 text-lg text-center">
                <i class="fas fa-times-circle fa-3x" style="color: #dc3545"></i>
              </h6>
              <p class="text-lg text-center" style="color: #721c24;">
                {{ errorMessage }}
              </p>
              <div class="text-center mt-4">
                <button class="btn btn-dark" @click="goToFormulario">
                  Volver al Formulario
                </button>
              </div>
            </div>


          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import ArgonButton from "@/components/ArgonButton.vue";
import { ref, computed, onMounted, onBeforeMount, onBeforeUnmount, watch } from "vue";
import Swal from "sweetalert2";
import { userInfoStore } from "@/store/userInfoStore";
import axios from "axios";
import { useStore } from "vuex";
import { useRouter } from 'vue-router';
import { BACK_END_URL, API_KEY_TELEFONO } from '@/utilities/config';

// Variables reactivas
const code = ref(["", "", "", "", "", ""]);
const getCode = computed(() => code.value.join(""));
const loading = ref(false);
const successMessageSent = ref(false);
const resendingCode = ref(false);
const userInfo = userInfoStore();
const phone = ref("");
const store = useStore();
const toggleDefaultLayout = () => store.commit("toggleDefaultLayout");
const usuarioRol = computed(() => sessionStorage.getItem('usuarioRol'));
const router = useRouter();
const errorOccurred = ref(false);
const errorMessage = ref("Ha ocurrido un error inesperado.");

const goToInicio = () => {
  router.push('/inicio');
};

const goToFormulario = () => {
  router.push('/elector');
};

const isButtonDisabled = computed(() => {
  return code.value.includes("") || loading.value;
});

/*
onBeforeMount(() => {
  store.commit("navbarMinimize");
  toggleDefaultLayout();
});*/

/*
onBeforeUnmount(() => {
  if (usuarioRol.value === 'usuario') {
    toggleDefaultLayout();
  }  
});*/

onMounted(async () => {

  const payload = JSON.parse(JSON.stringify(userInfo.getPayload()));
  if (payload && payload.telefono) {
    phone.value = payload.telefono;
  }

  try {
    // Update user information first
    await updateUserInfo();

    // Then send verification code
    await sendVerificationCode();
  } catch (error) {
    console.error("Error in onMounted:", error);
    errorOccurred.value = true;
    errorMessage.value = "Error al inicializar la verificación. Inténtelo nuevamente.";
  }
});

const updateUserInfo = async () => {
  const payload = userInfo.getPayload();
  if (!payload) {
    throw new Error("No payload found");
  }
  const token = sessionStorage.getItem("token");  

  try {   
    await axios.put(
      `${BACK_END_URL}/analytics/update/${payload.cedula}`,
      payload,
      {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      }
    );
  } catch (error) {
    console.error("Error updating user info:", error);
    throw error;
  }
};

const sendVerificationCode = async () => {
  const payload = userInfo.getPayload();
  if (!payload || !payload.telefono) {
    throw new Error("No phone number found in payload");
  }
  

  try {

  const response = await axios.post(
    `${BACK_END_URL}/verificacion`,
    {
      TELEFONO: String(payload.telefono)
    },
    {
      headers: {
        'Content-Type': 'application/json',
        'x-api-key-telefono': API_KEY_TELEFONO
      }
    }
  );

} catch (error) {
  console.error("Error details:", {
    message: error.message,
    response: error.response?.data, // Backend error message (if any)
    config: error.config?.headers  // Check what headers were actually sent
  });
  throw error;
}
};

const sendCodeSuccess = async () => {
  loading.value = true;
  errorOccurred.value = false;

  const payload = JSON.parse(JSON.stringify(userInfo.getPayload()));

  if (!payload) {
    console.error("No payload found!");
    Swal.fire({
      icon: "error",
      title: "Error",
      text: "No se encontró la información del usuario. Inténtelo nuevamente.",
    });
    loading.value = false;
    return;
  }

  try {
    const isCodeValid = await validateCode();

    if (isCodeValid) {
      successMessageSent.value = true;
    }
  } catch (error) {
    console.error("Error submitting data:", error);
    errorOccurred.value = true;
    errorMessage.value = "Error al registrar la información. Inténtelo nuevamente.";
  } finally {
    loading.value = false;
  }
};

const validateCode = async () => {
  try {
    const payload = userInfo.getPayload();
    if (!payload || !payload.telefono || !payload.cedula) {
      throw new Error("Missing required user information");
    }

    const response = await axios.post(
      `${BACK_END_URL}/verificacion/validar`,
      {
        CEDULA: parseInt(payload.cedula, 10),
        TELEFONO: String(payload.telefono),
        CODIGO: parseInt(getCode.value, 10)
      },
      {
        headers: {
          'Content-Type': 'application/json',
          'x-api-key-telefono': API_KEY_TELEFONO
        }
      }
    );

    if (response.data.valido === true) {
      return true;
    } else {
      errorOccurred.value = true;
      errorMessage.value = "El código de verificación es incorrecto. Por favor, inténtelo de nuevo.";
      return false;
    }
  } catch (error) {
    console.error("Error verifying code:", error);
    errorOccurred.value = true;
    errorMessage.value = "Error al verificar el código. Inténtelo nuevamente.";
    return false;
  }
};

const resendCode = async () => {
  if (resendingCode.value) return;

  resendingCode.value = true;

  try {
    await sendVerificationCode();

    Swal.fire({
      icon: "success",
      title: "¡Código reenviado!",
      text: "Por favor revise su número de teléfono.",
      confirmButtonText: "Aceptar",
    });
  } catch (error) {
    console.error("Error resending code:", error);
    Swal.fire({
      icon: "error",
      title: "Error",
      text: "Hubo un problema al reenviar el código. Inténtelo nuevamente.",
    });
  } finally {
    setTimeout(() => {
      resendingCode.value = false;
    }, 60000);
  }
};

const moveToNext = ($event, index) => {
  const target = $event.target;
  if (target.value.length === 1) {
    setTimeout(() => {
      const nextInput = target.parentElement.nextElementSibling?.querySelector("input");
      if (nextInput) nextInput.focus();
    }, 10);
  }
};

const moveToPrevious = ($event, index) => {
  if ($event.key === "Backspace" && code.value[index - 1] === "") {
    setTimeout(() => {
      const prevInput = $event.target.parentElement.previousElementSibling?.querySelector("input");
      if (prevInput) prevInput.focus();
    }, 10);
  }
};

watch(successMessageSent, (newValue) => {
  if (newValue && usuarioRol.value !== 'usuario') {
    setTimeout(() => {
      goToFormulario();
    }, 1500);
  }
});
</script>

<style>
.form-row {
  --bs-gutter-x: none !important;
}

input.form-control {
  background-color: transparent;
  border: 0cm;
  border-bottom: 1.7px solid #4b4b4b;
  font-size: small;
  margin: 0%;
  font-weight: 600;
  padding-left: 6px;
}


input.form-control.form-control-lg {
  border: 1.7px solid #4b4b4b;
  padding: 0.75rem 2rem;
  width: 80%;
  border-radius: 0.5rem;
  --bs-gutter-x: none;
}

.list-group-item:first-child {
  border-top-left-radius: 0.5rem !important;
  border-top-right-radius: 0.5rem !important;
}

.list-group-item:last-child {
  border-bottom-right-radius: 0.5rem !important;
  border-bottom-left-radius: 0.5rem !important;
}
</style>
